<script setup>
import { computed } from 'vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import { isWahaInbox } from 'dashboard/api/wahaManager';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

defineOptions({ inheritAttrs: false });

const isWhatsapp = computed(
  () =>
    isWahaInbox(props.inbox) ||
    props.inbox.channel_type === 'Channel::Whatsapp' ||
    (props.inbox.channel_type === 'Channel::TwilioSms' &&
      props.inbox.medium === 'whatsapp')
);
</script>

<template>
  <span v-if="isWhatsapp" class="inline-flex" v-bind="$attrs">
    <span
      role="img"
      aria-label="WhatsApp"
      class="i-ri-whatsapp-line size-full text-[#2bbd35]"
    />
  </span>
  <ChannelIcon v-else :inbox="inbox" v-bind="$attrs" />
</template>
